/// FOURJS_START_COPYRIGHT(D,2015)
/// Property of Four Js*
/// (c) Copyright Four Js 2015, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

modulum("StyleBehaviorBase", ["BehaviorBase"], function (context, cls) {
  /**
   * @class StyleBehaviorBase
   * @memberOf classes
   * @extends classes.BehaviorBase
   */
  cls.StyleBehaviorBase = context.oo.Class(cls.BehaviorBase, function ($super) {
    return /** @lends classes.StyleBehaviorBase.prototype */ {
      __name: "StyleBehaviorBase",

      /**
       * Test if style attribute is "yes" like
       * @param {number|string|Boolean} sa Style attribute
       * @returns {Boolean} True if Style Attribute is a yes or equivalent
       */
      isSAYesLike: function (sa) {
        return sa === 1 || sa === "1" || sa === "yes" || sa === "true" || sa === true;
      },

      /**
       * Test if style attribute is "no" like
       * @param {number|string|Boolean} sa Style attribute
       * @returns {Boolean} True if Style Attribute is a no or equivalent
       */
      isSANoLike: function (sa) {
        return sa === 0 || sa === "0" || sa === "no" || sa === "false" || sa === "none" || sa === false;
      }
    };
  });
});
